import { Toaster, toast } from "react-hot-toast";
import ToastTypes from "../enum/ToastTypes";
import toastConfig from "../config/toastConfig";

export const showToast = (message, type = ToastTypes.SUCCESS) => {
  const config = toastConfig[type] || {}; 
  toast[type](message, config);
};

const ToastProvider = ({ children }) => {
  return (
    <>
      {children}
      <Toaster position="bottom-left" toastOptions={{ duration: 3000 }} />
    </>
  );
};

export default ToastProvider;
